<dx-popup
  [(visible)]="showModal"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="title ?? ''"
  [width]="width"
  [height]="height"
  [minWidth]="'700px'"
  [minHeight]="'500px'"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  (onHidden)="onClose()"
>
  <div *dxTemplate="let data of 'content'">        
    @if (reportUrl) {
      <dx-report-viewer 
        [reportUrl]="reportUrl" 
        [width]="'100%'" 
        [height]="'100%'"
      >
        <dxrv-request-options 
          [invokeAction]="invokeAction" 
          [host]="hostApiUrl"
        ></dxrv-request-options>
        <dxrv-callbacks 
          (BeforeRender)="onBeforeRender($event)"
        ></dxrv-callbacks>
      </dx-report-viewer>
    } @else {
      <app-component-loader />
    }
  </div>
</dx-popup>

